import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import useUserInfo from "./use-user-info";
import type { Demographics } from "@/model/demographics";
import { QueryKeys } from "@/constants";
import { queryClient } from "./use-query-client";
import type { CourtOrderDependentPayloadType } from "@/types";
import { fetchCourtOrderedDependents } from "@/services/user";
import type { CourtOrderDependentType } from "@/model/court-order-dependents";

const useCourtOrderDependentQuery = (): UseQueryResult<
  CourtOrderDependentType[],
  Error
> => {
  const userInfo = useUserInfo();
  const demographics = queryClient.getQueryData([
    QueryKeys.DEMOGRAPHICS,
    userInfo.username,
  ]) as Demographics | undefined;
  const payload: CourtOrderDependentPayloadType = {
    divisionId: userInfo.divisionId,
    groupId: userInfo.groupId,
    memberId: demographics?.memberId ?? "",
    planId: demographics?.planId ?? "",
    accessToken: userInfo.accessToken,
  };
  return useQuery({
    queryKey: [QueryKeys.COURT_ORDER_DEPENDENTS],
    queryFn: async () => {
      const courtOrderDependentResponse =
        await fetchCourtOrderedDependents(payload);
      return courtOrderDependentResponse.data;
    },
    enabled:
      Boolean(payload?.divisionId) &&
      Boolean(payload?.groupId) &&
      Boolean(payload?.memberId) &&
      Boolean(payload?.planId) &&
      Boolean(payload?.accessToken),
    staleTime: Infinity,
  });
};

export { useCourtOrderDependentQuery };
